/* Green Hills Coffee USA — front-end interactions
   Scroll reveal · mobile drawer · option swatches · PDP price recalc */
(function () {
  'use strict';

  // Signal JS is present so reveal elements may start hidden (CSS gates on .gh-reveal).
  document.documentElement.classList.add('gh-reveal');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Scroll reveal ----
       Entrance animation as a progressive enhancement. Critically, content must
       NEVER stay hidden: we reveal on intersection, reveal anything already in
       view on load, and a failsafe reveals everything shortly after so no
       product/section is ever stuck at opacity:0 (e.g. below the fold, long
       pages, or if the observer never fires). */
    var reveals = [].slice.call(document.querySelectorAll('.reveal'));
    function revealAll() { reveals.forEach(function (el) { el.classList.add('in'); }); }
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0, rootMargin: '0px 0px 15% 0px' });
      reveals.forEach(function (el, i) {
        el.style.transitionDelay = (Math.min(i % 3, 3) * 70) + 'ms';
        // Reveal immediately if already within (or near) the viewport on load.
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 0) * 1.05) {
          el.classList.add('in');
        } else {
          io.observe(el);
        }
      });
      // Failsafe: guarantee everything becomes visible even without scrolling.
      setTimeout(revealAll, 1000);
    } else {
      revealAll();
    }

    /* ---- Mobile nav drawer ---- */
    var drawer = document.querySelector('.gh-drawer');
    if (drawer) {
      var openers = document.querySelectorAll('[data-gh-drawer-open]');
      var closers = drawer.querySelectorAll('[data-gh-drawer-close], .gh-drawer__scrim');
      var open = function () { drawer.classList.add('is-open'); document.body.classList.add('gh-no-scroll'); };
      var close = function () { drawer.classList.remove('is-open'); document.body.classList.remove('gh-no-scroll'); };
      openers.forEach(function (b) { b.addEventListener('click', open); });
      closers.forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    /* ---- Generic single-select swatch groups (non-variant, e.g. filters demo) ---- */
    document.querySelectorAll('[data-gh-single]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.swatch, .chip');
        if (!btn || !group.contains(btn)) return;
        var active = group.querySelector('.is-active');
        if (active) active.classList.remove('is-active');
        btn.classList.add('is-active');
      });
    });
  });
})();
